'use client';

import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  setLoginErrorMessage,
  setIsAccessDenied,
  setOtpVerificationLocked,
} from '@/redux/reducers/auth-reducer';
import { EMAIL } from '@/constants';
import { cn } from '@/utils/cn';
import Icon from '../Icon';

function EmailInput({
  isInputBoxClicked,
  setIsInputBoxClicked,
  inputRef,
  clearingRef,
  onEnterPress,
  onBlur,
  handleClearMouseDown,
  handleClearMouseUp,
  email,
  setEmail,
  setIsInvalidEmail,
  onUserInput,
  activeTab,
}) {
  const dispatch = useDispatch();

  const { loginErrorMessage } = useSelector((state) => state.auth);

  const handleEmailChange = (e) => {
    dispatch(setOtpVerificationLocked(false));
    dispatch(setLoginErrorMessage(''));
    setIsInputBoxClicked(true);
    const emailInput = e.target.value;
    setEmail(emailInput);
    dispatch(setIsAccessDenied(false));
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (activeTab === EMAIL) {
      if (regex.test(emailInput)) {
        setIsInvalidEmail(false);
        onUserInput(emailInput);
      } else {
        setIsInvalidEmail(true);
      }
    }
  };

  return (
    <div className="relative w-full">
      <div
        className={cn(
          'flex flex-row items-center justify-center gap-3 pl-12 rounded-[4px] border !border-supreme-grey',
          { 'border !border-coarse-wool': isInputBoxClicked },
          { 'border !border-infrared-burn': loginErrorMessage },
        )}
      >
        <div className="w-[24px] h-[24px]">
          <Icon type="email" height="24px" width="24px" color="#5F6368" />
        </div>

        <input
          ref={inputRef}
          type="text"
          name="email"
          className="text-coarse-wool peer block w-full mr-16 px-0 py-16 text-16 font-normal leading-20 tracking-[0.32px] focus:outline-none focus:ring-0 placeholder:text-senate !placeholder:text-16 !placeholder:font-encode-sans !placeholder:font-normal autofill:!bg-white"
          maxLength={50}
          placeholder="Enter email address"
          value={email}
          onFocus={() => setIsInputBoxClicked(true)}
          onChange={handleEmailChange}
          onKeyUp={(e) => onEnterPress(e)}
          onBlur={() => {
            if (clearingRef.current) {
              clearingRef.current = false;
              return;
            }
            onBlur();
          }}
        />
        {email?.length ? (
          <div className="p-8 cursor-pointer">
            <Icon
              type={
                !isInputBoxClicked && loginErrorMessage ? 'info-error' : 'close'
              }
              height="24"
              width="24"
              color={
                !isInputBoxClicked && loginErrorMessage ? '#DE3730' : '#49525E'
              }
              onMouseDown={handleClearMouseDown}
              onMouseUp={handleClearMouseUp}
            />
          </div>
        ) : null}
      </div>
      <label
        htmlFor="email"
        className={`bg-white absolute top-[17px] left-3 text-14 font-medium leading-20 tracking-[0.28px] duration-300 transform -translate-y-6 px-[6px] ${
          loginErrorMessage ? '!text-infrared-burn' : 'text-senate'
        }`}
      >
        Email address
      </label>
    </div>
  );
}

export default EmailInput;
